var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"width":"13px","src":require("@/assets/icon/trash.png"),"alt":"filterIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }